import {
  Card,
  CardButton,
  CardContent,
  CardDivider,
  CardProps,
  Icon,
  Text,
  hooks,
} from '@bitrise/bitkit';
import React, { FunctionComponent, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { URLStateContext } from '../../URLState/URLState';

interface Props extends CardProps {
  onCardButtonClick?: (e: MouseEvent) => void;
  toPath?: string;
  toText?: string;
}

const OverviewCard: FunctionComponent<Props> = ({
  children,
  onCardButtonClick,
  toPath,
  toText,
  ...rest
}) => {
  const { to } = useContext(URLStateContext);
  const match = hooks.useMediaQuery(['564px']);

  return (
    <Card {...rest} direction="vertical" elevation="x2" borderRadius="x4" grow>
      <CardContent paddingHorizontal={match('564px') ? 'x16' : 'x4'} paddingVertical="x12" grow>
        {children}
      </CardContent>

      {toPath && (
        <>
          <CardDivider />
          <CardButton Component={RouterLink} to={to(toPath)} onClick={onCardButtonClick}>
            <Text>{toText}</Text>
            <Icon name="ArrowForward" />
          </CardButton>
        </>
      )}
    </Card>
  );
};

export default OverviewCard;
